import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Container, Col, Row, Button, Text } from 'ui';
import {
  Character,
  CharacterPageBackground,
  WithCharacterBackground,
} from 'ui/characters';
import RoundedHeader from 'ui/layouts/RoundedHeader';

import s from './SingleTypeLandingHeader.module.scss';

const cx = cn.bind(s);

const descriptionText = `The Personality Type Indicator is a popular
self-report inventory designed to identify someone’s personality
type and is one of the most widely used psychology tools today.`;

const SingleTypeLandingHeader = ({
  type,
  longType,
  gender = 'male',
  group,
  skinTone = 0,
  color,
  className,
  ...attrs
}) => (
  <RoundedHeader color="white" className={cx('wrapper', color)}>
    <Container className={cx(className, 'container')} {...attrs}>
      <Row>
        <Col
          xl={{ span: 5, offset: 0 }}
          lg={{ offset: 1, span: 5 }}
          md={{ offset: 1, span: 10 }}
          xs={12}
          className={cx('textCol')}
        >
          <h2
            className={cx('title', 'mobile-header-1 md:tp-tablet-header-1 xl:tp-header-1')}
          >
            Are you the {longType} ?
          </h2>
          <h3 className={cx('type')}>{type.toUpperCase()} type</h3>
          <Text className={cx('desktopText')}>{descriptionText}</Text>
        </Col>
        <Col
          xl={{ offset: 1, span: 5 }}
          lg={{ offset: 0, span: 5 }}
          md={{ offset: 3, span: 6 }}
          xs={12}
          className={cx('illustrationCol')}
        >
          <WithCharacterBackground
            position="center"
            transparent={false}
            color={color}
            extra={<CharacterPageBackground group={group} />}
          >
            <Character type={type} gender={gender} tone={skinTone} />
          </WithCharacterBackground>
        </Col>
      </Row>
      <Row className={cx('tabletRow')}>
        <Col md={{ offset: 1, span: 10 }} xs={12}>
          <Text>{descriptionText}</Text>
        </Col>
      </Row>
      <div className={cx('actionRow')}>
        <Button as="a" href={'/free-personality-test'}>
          Take the test
        </Button>
      </div>
    </Container>
  </RoundedHeader>
);

SingleTypeLandingHeader.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default SingleTypeLandingHeader;
